export const SLOTS = {
  actionsStart: "actions-start",
  actionsEnd: "actions-end",
};

export const CSS = {
  icon: "icon",
  header: "header",
  headerContent: "header-content",
  actionsStart: "actions-start",
  actionsEnd: "actions-end",
  headerText: "header-text",
  heading: "heading",
  description: "description",
  expandIcon: "expand-icon",
  content: "content",
  iconStart: "icon--start",
  iconEnd: "icon--end",
  headerContainer: "header-container",
};

export const IDS = {
  section: "section",
  sectionToggle: "section-toggle",
};
